import { formatDate } from '@findy-code/utils/date';
import { Heading } from '@findy-code/yuffie/ui/heading';
import { Stack } from '@findy-code/yuffie/ui/stack';
import { Text } from '@findy-code/yuffie/ui/text';

import styles from './link-card-body.module.scss';

type Props = {
  title?: string | null;
  publishedAt?: string | null;
};

export const LinkCardBody = ({ title, publishedAt }: Props) => {
  return !(title || publishedAt) ? null : (
    <Stack className={styles.body} justify="space-between">
      {title && (
        <Heading as="h4" className={styles.title} font="heading-s">
          {title}
        </Heading>
      )}
      {publishedAt && (
        <Text className={styles.date} font="caption-m">
          公開日時 {formatDate(publishedAt, 'yyyy/MM/dd HH:mm')}
        </Text>
      )}
    </Stack>
  );
};
